import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, LineChart, Line } from "recharts";
import { useIsMobile } from "@/hooks/use-mobile";

interface CompanyJobViewsChartProps {
  data: { date: string; views: number; clicks: number }[];
  type?: "line" | "bar";
}

export function CompanyJobViewsChart({ data, type = "line" }: CompanyJobViewsChartProps) {
  const isMobile = useIsMobile();
  const chartHeight = isMobile ? 220 : 300;

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base md:text-lg">Visualizações e Cliques ao Longo do Tempo</CardTitle>
        <CardDescription>Últimos 30 dias de atividade</CardDescription>
      </CardHeader>
      <CardContent className="px-2 md:px-6">
        <ResponsiveContainer width="100%" height={chartHeight}>
          {type === "line" ? (
            <LineChart data={data} margin={isMobile ? { left: -20, right: 5 } : undefined}>
              <CartesianGrid strokeDasharray="3 3" className="stroke-muted" />
              <XAxis 
                dataKey="date" 
                className="text-xs"
                tick={{ fill: 'hsl(var(--muted-foreground))', fontSize: isMobile ? 10 : 12 }}
                interval={isMobile ? 'preserveStartEnd' : undefined}
              />
              <YAxis 
                className="text-xs"
                tick={{ fill: 'hsl(var(--muted-foreground))', fontSize: isMobile ? 10 : 12 }}
                width={isMobile ? 30 : 60}
              />
              <Tooltip 
                contentStyle={{
                  backgroundColor: 'hsl(var(--card))',
                  border: '1px solid hsl(var(--border))',
                  borderRadius: '6px',
                  fontSize: isMobile ? '12px' : '14px'
                }}
              />
              <Line 
                type="monotone" 
                dataKey="views" 
                stroke="hsl(var(--primary))"
                strokeWidth={2}
                name="Visualizações"
                dot={!isMobile}
              />
              <Line 
                type="monotone" 
                dataKey="clicks" 
                stroke="hsl(var(--chart-2))"
                strokeWidth={2}
                name="Cliques"
                dot={!isMobile}
              />
            </LineChart>
          ) : (
            <BarChart data={data} margin={isMobile ? { left: -20, right: 5 } : undefined}>
              <CartesianGrid strokeDasharray="3 3" className="stroke-muted" />
              <XAxis 
                dataKey="date" 
                className="text-xs"
                tick={{ fill: 'hsl(var(--muted-foreground))', fontSize: isMobile ? 10 : 12 }}
                interval={isMobile ? 'preserveStartEnd' : undefined}
              />
              <YAxis 
                className="text-xs"
                tick={{ fill: 'hsl(var(--muted-foreground))', fontSize: isMobile ? 10 : 12 }}
                width={isMobile ? 30 : 60}
              />
              <Tooltip 
                contentStyle={{
                  backgroundColor: 'hsl(var(--card))',
                  border: '1px solid hsl(var(--border))',
                  borderRadius: '6px',
                  fontSize: isMobile ? '12px' : '14px'
                }}
              />
              <Bar 
                dataKey="views" 
                fill="hsl(var(--primary))"
                radius={[4, 4, 0, 0]}
                name="Visualizações"
              />
              <Bar 
                dataKey="clicks" 
                fill="hsl(var(--chart-2))"
                radius={[4, 4, 0, 0]}
                name="Cliques"
              />
            </BarChart>
          )}
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
}
